import { render, staticRenderFns } from "./ChangeLogTable.vue?vue&type=template&id=6333993d&scoped=true"
import script from "./ChangeLogTable.vue?vue&type=script&lang=js"
export * from "./ChangeLogTable.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogTable.vue?vue&type=style&index=0&id=6333993d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6333993d",
  null
  
)

export default component.exports